<template>
	<div class="report_number_card">
		<div class="report_number_card_item" v-for="(item,index) in list" :key="index">
			<div class="value" :style="`color:${item.color}`">{{item.value||'-'}}</div>
			<div class="label">{{ item.label }}</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'reportNumberCard',
    props: {
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="less" scoped>
.report_number_card {
	background: rgba(21, 197, 206, 0.05);
	border: 1px solid @primary;
	display: flex;
	text-align: center;
	align-items: center;
	border-radius: 18px;
	height: 175px;
	&_item {
		flex: 1;
		.value {
			font-size: 48px;
			margin-bottom: 16px;
		}
		.label {
			font-size: 24px;
			color: @gray-9;
		}
	}
}
</style>